import React from 'react';
import type { MatchRow } from '../useCourseMatch';

// AIDEV-NOTE: What the LMS rosters say this assignment reaches, on the same row as whether it is
// delivering. These used to be a second table of the same assignments, which meant reading one row in
// two places to answer one question.
const Wiring = ({ row }: { row?: MatchRow }) => {
  if (row == null) return <span className="tw-text-spa-tertiary">—</span>;

  if (row.courses === 0) {
    return row.created_from == null
      ? <span className="tw-text-spa-tertiary">Never linked to a course</span>
      : (
        <span>
          <span className="tw-text-spa-primary">
            {`Created from ${row.created_from.course_title ?? row.created_from.course_id}`}
          </span>
          <span className="tw-block tw-text-sm tw-text-spa-tertiary">
            {`deep link ${row.created_from.seconds_before}s before, never linked`}
            {row.created_from.alternatives > 0 && ` · ${row.created_from.alternatives} other launches`}
          </span>
        </span>
      );
  }

  return (
    <span>
      <span className="tw-text-spa-primary">
        {row.reaches.length === 0
          ? 'No class matched confidently'
          : `Serves ${row.reaches.map(c => c.name ?? c.id).join(', ')}`}
      </span>
      {row.stranded.length > 0 && (
        <span className="tw-block tw-text-sm tw-text-spa-error">
          {`cannot reach ${row.stranded.map(c => c.name ?? c.id).join(', ')}`}
        </span>
      )}
    </span>
  );
};

export default Wiring;
